<template>

    <div class="text unselectable" :class="$mq">

        {{ text }}

    </div>
  
</template>

<script>
import { EventBus } from '../events/eventbus.js';

export default {
    data: function() {
        return {
            text: 'De Rivier'
        }
    },
    created() {
        EventBus.$on('language', (language) => {
            language === 'ENGLISH' ? this.text = 'The River' : this.text = 'De Rivier';
        })
    }
}
</script>

<style lang="scss" scoped>

.text {
    font-size: 7.2rem;
    font-family: 'Nanum Extra Bold';
    text-transform: uppercase;
    letter-spacing: 3.5rem;
    font-weight: 100;

    &.phone {
        font-size: 5.2rem;
        letter-spacing: 1.5rem;
    }

    &.tablet {
        font-size: 6.2rem;
        letter-spacing: 2rem;
    }
}

</style>